<template>
  <div class="browser-root">
    <!-- Navigatsiya va Qidiruv -->
    <div class="nav-bar">
      <div class="nav-inner">
        <!-- Breadcrumb -->
        <nav class="breadcrumb-nav">
          <a href="#" @click.prevent="resetSelection">Brendlar</a>
          <template v-if="showAllItems && !selectedBrand">
            <span class="bc-sep">/</span><span class="bc-active">Barchasi</span>
          </template>
          <template v-if="selectedBrand">
            <span class="bc-sep">/</span>
            <a href="#" @click.prevent="backToBrand">{{
              selectedBrand.name
            }}</a>
          </template>
          <template v-if="selectedModel">
            <span class="bc-sep">/</span
            ><span class="bc-active">{{ selectedModel.name }}</span>
          </template>
        </nav>

        <!-- Qidiruv -->
        <div class="search-box">
          <input
            type="text"
            v-model="filter"
            @input="onSearch"
            class="search-input"
            placeholder="Qidirish..."
          />
        </div>

        <!-- Tab tugmalari -->
        <div class="tab-group" v-if="!productsOnly">
          <button
            @click="activeTab = 'product'"
            :class="['tab-btn', activeTab === 'product' ? 'active' : '']"
          >
            Mahsulotlar
          </button>
          <button
            @click="activeTab = 'package'"
            :class="['tab-btn', activeTab === 'package' ? 'active' : '']"
          >
            Xizmatlar
          </button>
        </div>
      </div>
    </div>

    <!-- Tanlov -->
    <div class="browser-body">
      <!-- 1. Brendlar -->
      <div v-if="!selectedBrand && !showAllItems" class="brand-grid">
        <div class="brand-card all-card" @click="showAll">
          <span class="all-icon">&#9776;</span>
          <span class="brand-label">Barchasi</span>
        </div>
        <div
          v-for="brand in brandList"
          :key="brand.id"
          class="brand-card"
          @click="selectBrand(brand)"
        >
          <img :src="imageUrl + brand.image" alt="" class="brand-img" />
          <span class="brand-label">{{ brand.name }}</span>
        </div>
      </div>

      <!-- 2. Modellar + Mahsulotlar/Xizmatlar -->
      <template v-else-if="selectedBrand && !selectedModel && !showAllItems">
        <div v-if="modelList.length" class="brand-grid mb-3">
          <div
            v-for="model in modelList"
            :key="model.id"
            class="brand-card"
            @click="selectModel(model)"
          >
            <img :src="imageUrl + model.image" alt="" class="brand-img" />
            <span class="brand-label">{{ model.name }}</span>
          </div>
        </div>
        <div class="section-title">
          {{ activeTab === "package" ? "Xizmatlar" : "Mahsulotlar" }}
        </div>
        <!-- Xizmat paketlari -->
        <div v-if="activeTab === 'package'" class="items-grid">
          <div
            v-for="pkg in packages"
            :key="pkg.id"
            class="item-card pkg-card"
            :class="{ 'item-added': getPackageCount(pkg.id) > 0 }"
            @click="addPackage(pkg)"
          >
            <div class="ic-header">
              <div class="ic-name">{{ pkg.name }}</div>
              <div v-if="pkg.model" class="ic-sub">{{ pkg.model.name }}</div>
            </div>
            <div class="ic-prices">
              <div
                class="price-box"
                :class="{ active: saleType === 'chakana' }"
              >
                <span class="p-tag ch">Ch</span>
                <span class="p-amount">{{
                  formatSumma(
                    Number(pkg.labor_price_chakana || 0) +
                      Number(pkg.redo_price_chakana || 0)
                  )
                }}</span>
              </div>
              <div class="price-box" :class="{ active: saleType === 'optom' }">
                <span class="p-tag op">Op</span>
                <span class="p-amount">{{
                  formatSumma(
                    Number(pkg.labor_price_optom || 0) +
                      Number(pkg.redo_price_optom || 0)
                  )
                }}</span>
              </div>
            </div>
            <div
              v-if="getPackageCount(pkg.id) > 0"
              class="qty-control"
              @click.stop
            >
              <button
                class="qty-btn"
                @click.stop="$emit('decrease-package', pkg.id)"
              >
                −
              </button>
              <span class="qty-num">{{ getPackageCount(pkg.id) }}</span>
              <button class="qty-btn" @click.stop="addPackage(pkg)">+</button>
            </div>
            <button v-else class="add-btn">+</button>
          </div>
          <div v-if="packages.length === 0" class="empty-msg">
            Xizmat paketlari topilmadi
          </div>
        </div>
        <!-- Mahsulotlar -->
        <div v-else class="items-grid">
          <div
            v-for="item in productlist"
            :key="item.id"
            class="item-card"
            :class="{ 'item-added': getProductCount(item.id) > 0 }"
            @click="$emit('add-product', item)"
          >
            <div class="ic-header">
              <div class="ic-name">{{ item.name || item.extra_name }}</div>
              <div class="ic-sub">Qoldiq: {{ item.balance }}</div>
            </div>
            <div class="ic-prices">
              <div
                class="price-box"
                :class="{ active: saleType === 'chakana' }"
              >
                <span class="p-tag ch">Ch</span>
                <span class="p-amount">{{
                  formatSumma(getPrice(item, "chakana"))
                }}</span>
              </div>
              <div class="price-box" :class="{ active: saleType === 'optom' }">
                <span class="p-tag op">Op</span>
                <span class="p-amount">{{
                  formatSumma(getPrice(item, "optom"))
                }}</span>
              </div>
            </div>
            <div
              v-if="getProductCount(item.id) > 0"
              class="qty-control"
              @click.stop
            >
              <button
                class="qty-btn"
                @click.stop="$emit('decrease-product', item.id)"
              >
                −
              </button>
              <span class="qty-num">{{ getProductCount(item.id) }}</span>
              <button class="qty-btn" @click.stop="$emit('add-product', item)">
                +
              </button>
            </div>
            <button v-else class="add-btn">+</button>
          </div>
          <div v-if="productlist.length === 0" class="empty-msg">
            Mahsulot topilmadi
          </div>
        </div>
      </template>

      <!-- 3. Xizmatlar yoki Mahsulotlar -->
      <template v-else>
        <!-- Xizmat paketlari -->
        <div v-if="activeTab === 'package'" class="items-grid">
          <div
            v-for="pkg in packages"
            :key="pkg.id"
            class="item-card pkg-card"
            :class="{ 'item-added': getPackageCount(pkg.id) > 0 }"
            @click="addPackage(pkg)"
          >
            <div class="ic-header">
              <div class="ic-name">{{ pkg.name }}</div>
              <div v-if="pkg.model" class="ic-sub">{{ pkg.model.name }}</div>
            </div>
            <div class="ic-prices">
              <div
                class="price-box"
                :class="{ active: saleType === 'chakana' }"
              >
                <span class="p-tag ch">Ch</span>
                <span class="p-amount">{{
                  formatSumma(
                    Number(pkg.labor_price_chakana || 0) +
                      Number(pkg.redo_price_chakana || 0)
                  )
                }}</span>
              </div>
              <div class="price-box" :class="{ active: saleType === 'optom' }">
                <span class="p-tag op">Op</span>
                <span class="p-amount">{{
                  formatSumma(
                    Number(pkg.labor_price_optom || 0) +
                      Number(pkg.redo_price_optom || 0)
                  )
                }}</span>
              </div>
            </div>
            <div
              v-if="getPackageCount(pkg.id) > 0"
              class="qty-control"
              @click.stop
            >
              <button
                class="qty-btn"
                @click.stop="$emit('decrease-package', pkg.id)"
              >
                −
              </button>
              <span class="qty-num">{{ getPackageCount(pkg.id) }}</span>
              <button class="qty-btn" @click.stop="addPackage(pkg)">+</button>
            </div>
            <button v-else class="add-btn">+</button>
          </div>
          <div v-if="packages.length === 0" class="empty-msg">
            Xizmat paketlari topilmadi
          </div>
        </div>

        <!-- Mahsulotlar -->
        <div v-else class="items-grid">
          <div
            v-for="item in productlist"
            :key="item.id"
            class="item-card"
            :class="{ 'item-added': getProductCount(item.id) > 0 }"
            @click="$emit('add-product', item)"
          >
            <div class="ic-header">
              <div class="ic-name">{{ item.name || item.extra_name }}</div>
              <div class="ic-sub">Qoldiq: {{ item.balance }}</div>
            </div>
            <div class="ic-prices">
              <div
                class="price-box"
                :class="{ active: saleType === 'chakana' }"
              >
                <span class="p-tag ch">Ch</span>
                <span class="p-amount">{{
                  formatSumma(getPrice(item, "chakana"))
                }}</span>
              </div>
              <div class="price-box" :class="{ active: saleType === 'optom' }">
                <span class="p-tag op">Op</span>
                <span class="p-amount">{{
                  formatSumma(getPrice(item, "optom"))
                }}</span>
              </div>
            </div>
            <div
              v-if="getProductCount(item.id) > 0"
              class="qty-control"
              @click.stop
            >
              <button
                class="qty-btn"
                @click.stop="$emit('decrease-product', item.id)"
              >
                −
              </button>
              <span class="qty-num">{{ getProductCount(item.id) }}</span>
              <button class="qty-btn" @click.stop="$emit('add-product', item)">
                +
              </button>
            </div>
            <button v-else class="add-btn">+</button>
          </div>
          <div v-if="productlist.length === 0" class="empty-msg">
            Mahsulot topilmadi
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "ProductBrowser",
  props: {
    saleType: { type: String, default: "chakana" },
    cart: { type: Array, default: () => [] },
    // productsOnly — faqat mahsulot (Xizmatlar tab'ini yashiradi). Ustaga sovg'a sahifasi uchun.
    productsOnly: { type: Boolean, default: false }
  },
  emits: [
    "select-package",
    "add-product",
    "decrease-package",
    "decrease-product"
  ],
  data() {
    return {
      activeTab: "product",
      selectedBrand: null,
      selectedModel: null,
      showAllItems: false,
      filter: "",
      imageUrl: process.env.VUE_APP_BASE_URL + "api/v1/uploads/",
      brandList: [],
      modelList: [],
      packages: [],
      productlist: []
    };
  },
  mounted() {
    this.fetchBrands();
  },
  methods: {
    formatSumma(s) {
      return Number(s || 0).toLocaleString();
    },
    getProductCount(id) {
      const found = this.cart.find(
        c => c.type === "product" && c.id === id && !c.from_service
      );
      return found ? Number(found.qty) : 0;
    },
    getPackageCount(id) {
      const found = this.cart.find(c => c.type === "service" && c.id === id);
      return found ? Number(found.qty) : 0;
    },
    addPackage(pkg) {
      this.$emit("select-package", pkg);
    },
    getPrice(item, type) {
      if (!item.price_register) return 0;
      return type === "optom"
        ? item.price_register.optom_price
        : item.price_register.chakana_price;
    },
    async fetchBrands() {
      const res = await axios.get("api/v1/brand/");
      this.brandList = res.data;
    },
    async selectBrand(brand) {
      this.selectedBrand = brand;
      this.selectedModel = null;
      const res = await axios.get(`api/v1/model/?brand_id=${brand.id}`);
      this.modelList = res.data;
      await Promise.all([this.fetchProducts(), this.fetchPackages()]);
    },
    async selectModel(model) {
      this.selectedModel = model;
      await Promise.all([this.fetchProducts(), this.fetchPackages()]);
    },
    async showAll() {
      this.showAllItems = true;
      this.selectedBrand = null;
      this.selectedModel = null;
      await Promise.all([this.fetchProducts(), this.fetchPackages()]);
    },
    backToBrand() {
      this.selectedModel = null;
      this.showAllItems = false;
      this.productlist = [];
      this.packages = [];
    },
    resetSelection() {
      this.selectedBrand = null;
      this.selectedModel = null;
      this.showAllItems = false;
      this.productlist = [];
      this.packages = [];
    },
    onSearch() {
      if (this.selectedModel || this.selectedBrand || this.showAllItems) {
        this.fetchProducts();
        this.fetchPackages();
      }
    },
    async fetchProducts() {
      const skladId = localStorage.getItem("sklad_id");
      const res = await axios.post("api/v1/product/all-price-balance/0", {
        sklad_id: skladId,
        keyword: this.filter,
        model_id: this.selectedModel?.id || 0,
        brand_id: this.selectedBrand?.id || 0,
        limit: 50,
        page: 1
      });
      this.productlist = res.data;
    },
    async fetchPackages() {
      if (this.productsOnly) {
        this.packages = [];
        return;
      }
      const modelId = this.selectedModel?.id || 0;
      const res = await axios.get(`api/v1/repair_package?model_id=${modelId}`);
      this.packages = res.data;
    }
  }
};
</script>

<style scoped>
/* Nav bar */
.nav-bar {
  background: white;
  border-radius: 14px;
  padding: 10px 14px;
  margin-bottom: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}
.nav-inner {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

/* Breadcrumb */
.breadcrumb-nav {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 13px;
  flex-shrink: 0;
}
.breadcrumb-nav a {
  color: #3b82f6;
  text-decoration: none;
  font-weight: 600;
}
.breadcrumb-nav a:hover {
  text-decoration: underline;
}
.bc-sep {
  color: #cbd5e1;
}
.bc-active {
  color: #64748b;
  font-weight: 600;
}

/* Search */
.search-box {
  flex: 1;
  min-width: 140px;
}
.search-input {
  width: 100%;
  border: none;
  background: #f1f5f9;
  border-radius: 10px;
  padding: 8px 14px;
  outline: none;
  font-size: 13px;
}
.search-input:focus {
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

/* Tabs */
.tab-group {
  display: flex;
  border-radius: 10px;
  overflow: hidden;
  flex-shrink: 0;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
}
.tab-btn {
  background: #f1f5f9;
  color: #64748b;
  border: none;
  padding: 7px 18px;
  font-weight: 600;
  font-size: 13px;
  cursor: pointer;
  transition: 0.15s;
}
.tab-btn.active {
  background: #3b82f6;
  color: white;
}

/* Brand grid */
.brand-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
  gap: 8px;
}
.brand-card {
  background: white;
  border-radius: 12px;
  padding: 10px;
  text-align: center;
  cursor: pointer;
  transition: 0.2s;
  border: 1px solid transparent;
}
.brand-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);
  border-color: #3b82f6;
}
.brand-img {
  width: 100%;
  height: 48px;
  object-fit: contain;
  border-radius: 8px;
  margin-bottom: 4px;
}
.brand-label {
  display: block;
  font-weight: 600;
  font-size: 12px;
  color: #334155;
}
.all-card {
  border: 2px dashed #3b82f6;
  background: #eff6ff;
}
.all-icon {
  font-size: 26px;
  color: #3b82f6;
  display: block;
  margin-bottom: 2px;
}

/* Root layout — sticky nav + scrollable body */
.browser-root {
  display: flex;
  flex-direction: column;
  min-height: 0;
}
.nav-bar {
  position: sticky;
  top: 0;
  z-index: 5;
}
.browser-body {
  max-height: calc(100vh - 180px);
  overflow-y: auto;
  overflow-x: hidden;
  padding: 4px 4px 150px;
  -webkit-overflow-scrolling: touch;
}
@media (max-width: 560px) {
  .browser-body {
    max-height: calc(100vh - 220px);
    padding-bottom: 160px;
  }
}
.browser-body::-webkit-scrollbar {
  width: 6px;
}
.browser-body::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 3px;
}
.browser-body::-webkit-scrollbar-track {
  background: transparent;
}

/* Items grid — responsive 4 columns */
.items-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px;
}
@media (max-width: 1400px) {
  .items-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}
@media (max-width: 992px) {
  .items-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (max-width: 560px) {
  .items-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 6px;
  }
  .item-card {
    padding: 8px 10px;
    gap: 6px;
    border-radius: 10px;
  }
  .ic-header {
    padding-right: 24px;
  }
  .ic-name {
    font-size: 12px;
    -webkit-line-clamp: 2;
    line-clamp: 2;
  }
  .ic-sub {
    font-size: 10px;
  }
  .price-box {
    padding: 2px 6px;
    gap: 3px;
  }
  .p-tag {
    font-size: 9px;
    padding: 1px 4px;
  }
  .p-amount {
    font-size: 11px;
  }
  .add-btn {
    width: 22px;
    height: 22px;
    top: 6px;
    right: 6px;
    font-size: 13px;
    border-width: 1.5px;
  }
  .brand-grid {
    grid-template-columns: repeat(auto-fill, minmax(80px, 1fr)) !important;
    gap: 6px;
  }
  .brand-img {
    height: 38px;
  }
  .brand-label {
    font-size: 11px;
  }
  .nav-inner {
    gap: 6px;
  }
  .nav-bar {
    padding: 8px 10px;
    border-radius: 10px;
  }
  .tab-btn {
    padding: 6px 12px;
    font-size: 12px;
  }
  .search-input {
    font-size: 12px;
    padding: 7px 10px;
  }
  .breadcrumb-nav {
    font-size: 12px;
    width: 100%;
  }
}
@media (max-width: 380px) {
  .items-grid {
    grid-template-columns: 1fr;
  }
}

/* Item card */
.item-card {
  background: white;
  border-radius: 12px;
  padding: 12px 14px;
  cursor: pointer;
  transition: 0.15s;
  border: 1px solid #f1f5f9;
  display: flex;
  flex-direction: column;
  gap: 8px;
  position: relative;
}
.item-card:hover {
  background: #f8fafc;
  border-color: #e2e8f0;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
}
.pkg-card {
  border-left: 3px solid #a142f4;
}
.item-added {
  background: #f0e8ff !important;
  border-color: #a142f4;
}

.ic-header {
  padding-right: 30px;
}
.ic-name {
  font-weight: 700;
  font-size: 14px;
  color: #1e293b;
  line-height: 1.3;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}
.ic-sub {
  font-size: 12px;
  color: #94a3b8;
  margin-top: 2px;
}

/* Prices */
.ic-prices {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
}
.price-box {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 4px 8px;
  border-radius: 8px;
  background: #f8fafc;
  border: 1.5px solid transparent;
  transition: 0.15s;
}
.price-box.active {
  background: #ecfdf5;
  border-color: #10b981;
}
.p-tag {
  font-size: 10px;
  font-weight: 800;
  padding: 2px 5px;
  border-radius: 4px;
  line-height: 1;
}
.p-tag.ch {
  background: #dbeafe;
  color: #2563eb;
}
.p-tag.op {
  background: #fef3c7;
  color: #d97706;
}
.p-amount {
  font-weight: 800;
  font-size: 14px;
  color: #1e293b;
  white-space: nowrap;
}
.price-box.active .p-amount {
  color: #059669;
}

/* Add button */
.add-btn {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: 2px solid #10b981;
  background: white;
  color: #10b981;
  font-weight: bold;
  font-size: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 0.15s;
  line-height: 1;
}
.add-btn:hover {
  background: #10b981;
  color: white;
}
.add-btn.added {
  background: #a142f4;
  border-color: #a142f4;
  color: white;
}

/* Qty control (when item is already in cart) */
.qty-control {
  position: absolute;
  top: 8px;
  right: 8px;
  display: flex;
  align-items: center;
  gap: 2px;
  background: white;
  border: 1.5px solid #10b981;
  border-radius: 999px;
  padding: 2px;
  box-shadow: 0 2px 6px rgba(16, 185, 129, 0.18);
}
.qty-btn {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  border: none;
  background: #ecfdf5;
  color: #10b981;
  font-weight: 800;
  font-size: 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  padding: 0;
  transition: 0.15s;
}
.qty-btn:hover {
  background: #10b981;
  color: white;
}
.qty-num {
  min-width: 20px;
  text-align: center;
  font-weight: 800;
  font-size: 13px;
  color: #065f46;
  padding: 0 2px;
}
@media (max-width: 560px) {
  .qty-control {
    top: 6px;
    right: 6px;
    padding: 1px;
  }
  .qty-btn {
    width: 18px;
    height: 18px;
    font-size: 12px;
  }
  .qty-num {
    min-width: 16px;
    font-size: 11px;
  }
}

.section-title {
  font-size: 13px;
  font-weight: 700;
  color: #475569;
  margin: 14px 0 8px;
  padding-left: 4px;
  border-left: 3px solid #3b82f6;
  padding-left: 8px;
}
.empty-msg {
  grid-column: 1 / -1;
  text-align: center;
  padding: 32px 0;
  color: #94a3b8;
  font-size: 13px;
}
</style>
